/**
 * @description: 福利活动设置
 * @author: hwx
*/
<template>
    <div class="welfare-activity">
        <div class="wfa-list" v-show="showWfaList">
            <h1>福利活动设置</h1>
            <el-form :inline="true" :model="wfa_list_form">
                <el-form-item label="门店">
                    <el-select v-model="wfa_list_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动状态">
                    <el-select v-model="wfa_list_form.status" clearable placeholder="请选择活动状态">
                        <el-option label="未开始" value="-1"></el-option>
                        <el-option label="进行中" value="1"></el-option>
                        <el-option label="已结束" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="pull-right">
                    <el-button type="primary" @click="wfaAdd">新增活动</el-button>
                    <el-button type="primary" @click="getWfaTable(1)">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="wfa_table">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="name" label="活动名称"></el-table-column>
                <el-table-column prop="start_time" label="活动开始时间"></el-table-column>
                <el-table-column prop="end_time" label="活动结束时间"></el-table-column>
                <el-table-column prop="status_name" label="活动状态"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="wfaModify(scope.row.id, 'detail')" v-show="scope.row.status == '2'">详情</span>
                        <span class="text-blue" @click="wfaModify(scope.row.id, 'modify')" v-show="scope.row.status != '2'">修改</span>
                        <span class="text-blue" @click="wfaDel(scope.row)">删除</span>
                        <span class="text-blue" @click="wfaQrcode(scope.row)">活动二维码</span>
                        <span class="text-blue" @click="wfaUser(scope.row)">中奖名单</span>
                        <span class="text-blue" @click="wfaModify(scope.row.id, 'copyAdd')">复制新增</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="wfa_page"
                :total="wfa_total"
                @current-change="getWfaTable">
            </el-pagination>
            <!-- 活动二维码 -->
            <div class="wfa-qrcode-alert" ref="wfa_qrcode_alert">
                <div id="wfaQrcodeImg" class="wfa-qrcode-img"></div>
                <p>{{wfa_qrcode_name}}</p>
                <!-- <el-row>
                    <el-button type="primary" @click="wfaRowDl">下载到本地</el-button>
                </el-row> -->
            </div>
        </div>
        <!-- 中奖名单 -->
        <div class="wfa-user" v-show="showWfaUser">
            <h2>中奖名单</h2>
            <el-form :inline="true" :model="wfa_user_form">
                <el-form-item label="活动名称">
                    {{wfa_user_form.name}}
                </el-form-item>
                <el-form-item class="pull-right">
                    <!-- <el-button type="primary" @click="getRaceRank(1)">查询</el-button> -->
                    <el-button @click="backList">返回</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="user_table">
                <el-table-column prop="user_name" label="微信昵称"></el-table-column>
                <el-table-column prop="user_img" label="微信头像">
                    <template slot-scope="scope">
                        <img :src="scope.row.user_img" class="wfa-user-img">
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="reward_info" label="奖品"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="user_page"
                :total="user_total"
                @current-change="getUserTable">
            </el-pagination>
        </div>
        <div class="wfa-edit" v-show="showWfaEdit">
            <h2>{{wfa_edit_tit}}</h2>
            <el-form :model="wfa_edit_form" label-width="130px">
                <el-form-item label="门店">
                    <el-select v-model="wfa_edit_form.shop_id" 
                    filterable 
                    placeholder="请选择门店" 
                    @change="wfaEditShop"
                    :disabled="wfa_edit_tit=='修改活动'">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动名称">
                    <el-input placeholder="请输入活动名称" v-model="wfa_edit_form.name"></el-input>
                </el-form-item>
                <el-form-item label="活动开始时间" class="wfa-start-wrap">
                    <div ref="wfa_start_main">
                        <el-input v-model="wfa_edit_form.start_time" class="el-ellipsis" placeholder="请选择活动开始时间"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="活动结束时间" class="wfa-end-wrap">
                    <div ref="wfa_end_main">
                        <el-input v-model="wfa_edit_form.end_time" class="el-ellipsis" placeholder="请选择活动结束时间"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="活动介绍">
                    <el-input placeholder="请输入活动介绍" v-model="wfa_edit_form.desc"></el-input>
                </el-form-item>
                <el-form-item
                    v-for="(item, index) in wfa_edit_form.goods"
                    :key="index"
                    :label="'奖品' + (index + 1)"
                >
                    <el-row class="wfa-edit-row">
                        <el-col :span="9">
                            <label class="el-form-item__label">奖品名称</label>
                            <el-input placeholder="请输入奖品名称" class="wfa-input-normal" v-model="item.name"></el-input>
                        </el-col>
                        <el-col :span="7">
                            <label class="el-form-item__label">得奖概率</label>
                            <el-input class="wfa-input-mini" v-model="item.probability"></el-input>
                            <span>%</span>
                        </el-col>
                        <el-col :span="7">
                            <label class="el-form-item__label">奖品数量</label>
                            <el-input class="wfa-input-mini" v-model="item.quantity"></el-input>
                        </el-col>
                    </el-row>
                    <el-row>
                        <label class="el-form-item__label">奖品图片</label>
                        <img :src="item.img" :id="item.img_id">
                        <el-button type="primary" @click="wfaPrizesAdd(index)">添加奖品券</el-button>
                    </el-row>
                    <el-table
                        :data="item.infos">
                        <el-table-column prop="gift_name" label="活动券名称"></el-table-column>
                        <el-table-column prop="gift_type_name" label="活动券类型"></el-table-column>
                        <el-table-column label="活动券数量">
                            <template slot-scope="scope">
                                <el-input placeholder="请输入正整数" v-model="item.infos[scope.$index].quantity" class="wfa-table-input" @blur="wfaCouponQuantity($event, index, scope.$index, scope.row.quantity)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="wfaPrizesDel(index, scope.$index)">删除</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item>
                    <el-button @click="backList">返回</el-button>
                    <el-button type="primary" @click="wfaEdit">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 详情 -->
        <div class="wfa-det" v-show="showWfaDet">
            <h2>活动详情</h2>
            <el-row>
                <label class="el-form-item__label">门店</label>
                <span>{{wfa_det.shop_name}}</span>
            </el-row>
            <el-row>
                <label class="el-form-item__label">活动名称</label>
                <span>{{wfa_det.name}}</span>
            </el-row>
            <el-row>
                <label class="el-form-item__label">活动开始时间</label>
                <span>{{wfa_det.start_time}}</span>
            </el-row>
            <el-row>
                <label class="el-form-item__label">活动结束时间</label>
                <span>{{wfa_det.end_time}}</span>
            </el-row>
            <el-row>
                <label class="el-form-item__label">活动介绍</label>
                <span>{{wfa_det.desc}}</span>
            </el-row>
            <el-row
                v-for="(item, index) in wfa_det.goods"
                :key="index"
                :label="'奖品' + (index + 1)"
            >
                <el-row class="wfa-edit-row">
                    <el-col :span="9">
                        <label class="el-form-item__label">奖品名称</label>
                        <span>{{item.name}}</span>
                    </el-col>
                    <el-col :span="7">
                        <label class="el-form-item__label">得奖概率</label>
                        <span>{{item.probability}}%</span>
                    </el-col>
                    <el-col :span="7">
                        <label class="el-form-item__label">奖品数量</label>
                        <span>{{item.quantity}}</span>
                    </el-col>
                </el-row>
                <el-row>
                    <label class="el-form-item__label">奖品图片</label>
                    <img :src="item.img">
                </el-row>
                <el-table
                    :data="item.infos">
                    <el-table-column prop="gift_name" label="活动券名称"></el-table-column>
                    <el-table-column prop="gift_type_name" label="活动券类型"></el-table-column>
                    <el-table-column prop="quantity" label="活动券数量"></el-table-column>
                </el-table>
            </el-row>
            <el-row>
                <el-button @click="backList">返回</el-button>
            </el-row>
        </div>
        <!-- 添加奖品 -->
        <div class="select-goods-wrap" ref="wfa_coupon_alert">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-select v-model="coupon_type" clearable filterable placeholder="请选择类型" @change="couponTypeChange">
                        <el-option label="优惠券" value="1"></el-option>
                        <el-option label="商品券" value="2"></el-option>
                        <el-option label="商品套餐券" value="3"></el-option>
                        <el-option label="开房套餐券" value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="10">
                    <el-input placeholder="请输入活动券名称" v-model="coupon_name"></el-input>
                </el-col>
                <el-col :span="6">
                    <el-button class="pull-right" type="primary" @click="getCouponTable(1)">查询</el-button>
                </el-col>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                ref="coupon_table"
                :data="coupon_table"
                @selection-change="getCouponSelect">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="type_name" label="类型"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZEMINI"
                :current-page.sync="coupon_page"
                :total="coupon_total"
                @current-change="getCouponTable">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import QRCode from 'qrcodejs2'
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                showWfaList: true,
                showWfaEdit: false,
                showWfaDet: false,
                showWfaUser: false,

                wfa_list_form: {
                    shop_id: '',
                    status: ''
                },
                wfa_page: 1,
				wfa_total: 0,
                wfa_table: [],
                wfa_qrcode_name: '',

                wfa_user_form: {
                    id: '',
                    shop_id: '',
                    name: ''
                },
                user_page: 1,
				user_total: 0,
                user_table: [],

                wfa_edit_id: '',
                wfa_edit_tit: '',
                wfa_edit_form: {
                    shop_id: '',
                    name: '',
                    start_time: '',
                    end_time: '',
                    desc: '',
                    goods: [{
                        name: '',
                        probability: '',
                        quantity: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'wfaImg0',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        quantity: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'wfaImg1',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        quantity: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'wfaImg2',
                        img_done: false,
                        infos: []
                    }]
                },
                wfa_det: {},
                coupon_type: '',
				coupon_name: '',
				coupon_page: 1,
				coupon_total: 0,
                coupon_table: [],
                coupon_table_select: [],
            }
        },
        mounted: function() {
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.wfa_list_form.shop_id = this.shop_list[0].id
                this.getWfaTable(1)
                this.initDate()
                this.wfaImgUpload('wfaImg0', 0)
                this.wfaImgUpload('wfaImg1', 1)
                this.wfaImgUpload('wfaImg2', 2)
            })
        },
        methods: {
            // 获取门店数据
			getShop: function(resolve) {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
                    console.log(err);
					layer.msg('出错啦');
				});
            },



            // 列表
			getWfaTable: function(page) {
				const _this = this;

				_this.loading = true;
                _this.wfa_page = page
				Vue.axios.post('WelfareActivity/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.wfa_list_form.shop_id,
                            "status": _this.wfa_list_form.status
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.wfa_total = Number(res.data.response.result.count)
						}
						_this.wfa_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 删除
			wfaDel(row) {
				const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('WelfareActivity/delData', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": row.id,
                                "shop_id": row.shop_id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getWfaTable(_this.wfa_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },
            // 关卡二维码
            wfaQrcode(row) {
                const src = new QRCode('wfaQrcodeImg', {
			        width: 200,
			        height: 200,
			        text: row.share_url // 设置二维码内容或跳转地址
                })
                // this.wfa_row_qrcode = src
                this.wfa_qrcode_name = row.name
                layer.open({
					type: 1,
					title: '活动二维码',
					skin: 'public-alert-skin',
					area: ['500px', ''],
                    content: $(this.$refs.wfa_qrcode_alert),
                    cancel: function() {
                        document.getElementById("wfaQrcodeImg").innerHTML = "";
                    }
				})
            },
            // 中奖名单
            wfaUser(row) {
                this.wfa_user_form.id = row.id
                this.wfa_user_form.shop_id = row.shop_id
                this.wfa_user_form.name = row.name
                this.getUserTable(1)
                this.showWfaList = false
                this.showWfaUser = true
            },
            getUserTable: function(page) {
				const _this = this;

                _this.loading = true
                _this.user_page = page
				Vue.axios.post('WelfareActivity/getRewardUserInfo', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "id": _this.wfa_user_form.id,
                            "shop_id": _this.wfa_user_form.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.user_total = Number(res.data.response.result.count)
						}
						_this.user_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 点击新增
			wfaAdd() {
                this.wfa_edit_id = ''
                this.wfa_edit_tit = '新增活动'
                this.wfa_edit_form = {
                    shop_id: this.shop_list[0].id,
                    name: '',
                    start_time: '',
                    end_time: '',
                    desc: '',
                    goods: [{
                        name: '',
                        probability: '',
                        quantity: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'wfaImg0',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        quantity: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'wfaImg1',
                        img_done: false,
                        infos: []
                    }, {
                        name: '',
                        probability: '',
                        quantity: '',
                        img: require('../../assets/images/upload_btn.png'),
                        img_id: 'wfaImg2',
                        img_done: false,
                        infos: []
                    }]
                }
                this.showWfaList = false
                this.showWfaEdit = true
			},
			// 点击修改
			wfaModify(id, type) {
                const _this = this;

                Vue.axios.post('WelfareActivity/getDetail', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        const row = res.data.response.result;

                        if(type === 'modify') {
                            _this.wfa_edit_id = row.id
                            _this.wfa_edit_tit = '修改活动'
                            _this.wfa_edit_form = {
                                shop_id: row.shop_id,
                                name: row.name,
                                start_time: row.start_time,
                                end_time: row.end_time,
                                desc: row.desc,
                                goods: []
                            }
                            row.goods.forEach((item, index) => {
                                _this.wfa_edit_form.goods.push({
                                    id: item.id,
                                    name: item.name,
                                    probability: item.probability,
                                    quantity: item.quantity,
                                    img: item.img,
                                    img_id: 'wfaImg' + index,
                                    img_done: true,
                                    infos: item.infos
                                })
                            })
                            _this.showWfaList = false
                            _this.showWfaEdit = true
                        } else if(type === 'copyAdd') {
                            _this.wfa_edit_id = ''
                            _this.wfa_edit_tit = '新增活动'
                            _this.wfa_edit_form = {
                                shop_id: row.shop_id,
                                name: row.name,
                                start_time: '',
                                end_time: '',
                                desc: row.desc,
                                goods: []
                            }
                            row.goods.forEach((item, index) => {
                                _this.wfa_edit_form.goods.push({
                                    name: item.name,
                                    probability: item.probability,
                                    quantity: item.quantity,
                                    img: item.img,
                                    img_id: 'wfaImg' + index,
                                    img_done: true,
                                    infos: item.infos
                                })
                            })
                            _this.showWfaList = false
                            _this.showWfaEdit = true
                        } else if(type === 'detail') {
                            _this.wfa_edit_id = ''
                            _this.wfa_edit_tit = '活动详情'
                            _this.wfa_det = row
                            _this.showWfaList = false
                            _this.showWfaDet = true
                        }
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 日期
			initDate: function() {
                const _this = this;

                $(_this.$refs.wfa_start_main).daterangepicker({
                    parentEl: '.wfa-start-wrap',
                    singleDatePicker: true,
                    // drops: 'up',
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    event.preventDefault()
                    _this.wfa_edit_form.start_time = start.format('YYYY-MM-DD HH:mm')
                });
                $(_this.$refs.wfa_end_main).daterangepicker({
                    parentEl: '.wfa-end-wrap',
                    singleDatePicker: true,
                    // drops: 'up',
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                }, function(start, end, label) {
                    event.preventDefault()
                    _this.wfa_edit_form.end_time = start.format('YYYY-MM-DD HH:mm')
                });
			},
            // 奖品图片
			wfaImgUpload: function(id, index) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: id, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: "jpg,jpeg,png,gif" }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'ticket_system'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                _this.wfa_edit_form.goods[index].img = host + "/" + dir + file_name;
								_this.wfa_edit_form.goods[index].img_done = true;
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传jpg,jpeg,png,gif文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },
            // 添加奖品
			wfaPrizesAdd: function(index) {
				const _this = this;

				_this.coupon_type = ''
				_this.coupon_name = ''
				_this.coupon_page = 1
				_this.getCouponTable(1)
				layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['添加活动券', true],
                    area: ['700px', '500px'], // 宽高
                    content: $(_this.$refs.wfa_coupon_alert)
                }, function() {
                    // 保存活动券
                    _this.coupon_table_select.forEach(_ => {
                        let isTrue = true;
                        for(let i = 0; i < _this.wfa_edit_form.goods[index].infos.length; i++) {
                            if(_this.wfa_edit_form.goods[index].infos[i].gift_id == _.id) {
                                isTrue = false
                                return false
                            }
                        }
                        if(isTrue) {
                            _this.wfa_edit_form.goods[index].infos.push({
                                gift_id: _.id,
                                gift_name: _.name,
                                gift_type: _.type,
                                gift_type_name: _.type_name,
                                quantity: 1
                            })
                        }
                    })
                    layer.msg('保存成功')
                    _this.$refs.coupon_table.clearSelection();
                });
			},
			wfaPrizesDel(i, j) {
				this.wfa_edit_form.goods[i].infos.splice(j, 1)
			},
			couponTypeChange(val) {
				this.getCouponTable(1);
			},
			getCouponTable: function(page) {
				const _this = this;

				_this.loading = true;
                Vue.axios.post('MerchantGift/getListToTicket', {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZEMINI,
							"shop_id": _this.wfa_edit_form.shop_id,
							"type": _this.coupon_type,
							"name": _this.coupon_name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.coupon_total = Number(res.data.response.result.total);
						}
						_this.coupon_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
			getCouponSelect(val) {
				this.coupon_table_select = val
            },
            wfaCouponQuantity(val, i, j, quantity) {
                if(!/^[1-9]\d*$/.test(quantity)) {
                    layer.msg('请输入正整数')
                    this.wfa_edit_form.goods[i].infos[j].quantity = 1
                }
            },
            // 新增、修改
			wfaEdit() {
                const _this = this;

                let isTrue = true;
                for(let i = 0; i < _this.wfa_edit_form.goods.length; i++) {
                    if(!_this.wfa_edit_form.goods[i].img_done) {
                        isTrue = false
                    }
                }
                if(!isTrue) {
                    layer.msg('请上传奖品图片')
                    return false
                }
                let data = {
                    "header": Vue.request_header,
					"request": {
						"param": {
                            "shop_id": _this.wfa_edit_form.shop_id,
                            "name": _this.wfa_edit_form.name,
                            "start_time": _this.wfa_edit_form.start_time,
                            "end_time": _this.wfa_edit_form.end_time,
                            "desc": _this.wfa_edit_form.desc,
                            "goods": _this.wfa_edit_form.goods
						}
					},
					"comment": ""
                };
                if(_this.wfa_edit_id) {
                    data.request.param.id = _this.wfa_edit_id;
                }
                Vue.axios({
					method: 'post',
					url: 'WelfareActivity/editData',
					data: data
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg('操作成功')
                        _this.getWfaTable(_this.wfa_page)
                        _this.showWfaList = true
						_this.showWfaEdit = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },

            wfaEditShop() {
                if(this.wfa_edit_form.goods.length > 0) {
                    this.wfa_edit_form.goods.forEach(item => {
                        item.infos = []
                    })
                }
            },

            // 返回列表
            backList() {
                this.showWfaList = true
                this.showWfaEdit = false
                this.showWfaDet = false
                this.showWfaUser = false
            }
        }
    }
</script>
<style lang="less" scoped>
    .select-goods-wrap {
        display: none;
    }
    .wfa-qrcode-alert {
        display: none;
        .wfa-qrcode-img {
            width: 200px;
            margin: 0 auto 20px;
        }
        p {
            text-align: center;
        }
    }
    .wfa-user {
        &-img {
            display: block;
            width: 80px;
        }
    }
    .wfa-edit {
        .el-form {
            .el-select {
                width: 400px;
            }
            .el-input {
                width: 400px;
            }
            .wfa-start-wrap {
                position: relative;
                width: 530px;
            }
            .wfa-end-wrap {
                position: relative;
                width: 530px;
            }
            .el-row {
                margin-bottom: 15px;
            }
            .wfa-table-input {
                width: 160px;
            }
            .wfa-edit-row {
                width: 663px;
                .wfa-input-normal {
                    width: 160px;
                }
                .wfa-input-mini {
                    width: 83px;
                }
                i {
                    color: #409eff;
                    font-size: 40px;
                    vertical-align: bottom;
                    cursor: pointer;
                }
            }
            img {
                float: left;
                width: 114px;
                height: 114px;
                margin: 0 15px 0 0;
                cursor: pointer;
            }
		}
    }
    .wfa-det {
        span {
            line-height: 40px;
            font-size: 14px;
        }
    }
</style>